import { mergeDeep } from '@/helpers/utils'
import { pickStickyVariant } from '@/modules/Landing/helpers/stickyVariant'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

type AbSmartly = { variantConfig: (experimentName: string) => Record<string, unknown> }

const EXPERIMENT_NAME = 'web_walking_gs_welcome_topic'

export default (schemas: LandingScreenSchema[], $absmartly?: AbSmartly): LandingScreenSchema[] => {
	const config = $absmartly?.variantConfig?.(EXPERIMENT_NAME)
	const variant = pickStickyVariant({ variants: config?.variants, cacheKey: EXPERIMENT_NAME })

	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			components: {
				LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
					title: variant?.title ?? $t('pages.landing.title_walking'),
					size: 'small',
					customStyles: {
						marginLeft: '3rem',
						marginRight: '3rem',
					},
				}),
			},
			config: {
				analytics: { screenId: variant?.id ?? 'unknown' },
			},
		},
		// Второй экран лендинга — age-выбор. Сюда доходит только treatment: control отсекается
		// раньше, getAppAreaExperiment отдаёт landing-часть лишь при treatment > 0.
		// Гейт по variant?.title, а не по variant: config вариантов заполняется руками в ABsmartly,
		// и запись без title дала бы пустой <h1> (LandingTitle рендерит через v-html), тогда как
		// лоадер выше упал бы на i18n-фолбэк — экраны разъехались бы. Пустой объект = мерж no-op.
		// size/uppercase дублируют age-walking.ts осознанно: mergeDeep заменяет фабрику целиком.
		variant?.title
			? {
					components: {
						LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
							title: variant.title,
							size: 'large',
							uppercase: true,
						}),
					},
				}
			: {},
	]

	return mergeDeep([...schemas], extensionSchema)
}
